<div class="heading-tab">
    <h3 class="heading"><i nz-icon nzType="user" nzTheme="outline"></i> {{_clientRole | technicalTranslate}}</h3>
    <div>
        <button nz-button nzType="primary" (click)="openCaptureClientModel()">
            <span class="m-r-5">{{searchAddText}}</span>
            {{_clientRole | technicalTranslate}}
        </button>
    </div>
</div>

<!--
With Ng-zorro 13, no need to specify empty state <nz-empty></nz-empty>. By default it shows the no-data on the screen, if list is empty.
-->

<div *ngIf="refreshClientDataGrid">
    <nz-table #genericClientDataTable [nzData]="capturedClientDataList" [nzShowPagination]="false">
        <thead>
            <tr>
                <th scope="col" [nzWidth]="'80px'">Sr. No.</th>
                <ng-container *ngFor="let config of uiConfig.columnsConfig">
                    <ng-container *ngIf="config.columnVisibility">
                        <th scope="col" [nzWidth]="config.width">{{config.fieldName}}</th>
                    </ng-container>
                </ng-container>
                <th scope="col" [nzWidth]="'260px'">Action</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of genericClientDataTable.data; let index = index;">
                <td>{{ index + 1 }}</td>
                <ng-container *ngFor="let config of uiConfig.columnsConfig">
                    <ng-container *ngIf="config.columnVisibility">
                        <ng-container *ngIf="config.isEditable; else showReadOnlyData">
                            <td>
                                <ng-container [ngSwitch]="config.fieldType">
                                    <div *ngSwitchCase="'COMBO'">
                                        <nz-select
                                            [(ngModel)]="data['flattenData'][config.flattenType][config.fieldKey]"
                                            (nzBlur)="updateClientTransactionData($event, index, config.fieldKey, config.flattenType)"
                                            class="w-100-pc-force">
                                            <nz-option
                                                *ngFor="let item of ((lookup$[config.lookupCd] | async) || lookupData[config.lookupCd])  as LookupList; trackBy:item?.lookupKey"
                                                [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option>
                                        </nz-select>
                                    </div>
                                    <div *ngSwitchCase="'NUMBER'">
                                        <nz-input-number
                                            [(ngModel)]="data['flattenData'][config.flattenType][config.fieldKey]"
                                            (nzBlur)="updateClientTransactionData($event, index, config.fieldKey, config.flattenType)"
                                            class="w-100-pc-force" [nzMin]="config.min || 1" [nzMax]="config.max || 100"
                                            [nzStep]="1" [nzFormatter]="formatterPercent"
                                            [nzParser]="parserPercent"></nz-input-number>
                                    </div>
                                    <div *ngSwitchDefault>
                                        <input nz-input
                                            [(ngModel)]="data['flattenData'][config.flattenType][config.fieldKey]"
                                            (ngModelChange)="updateClientTransactionData($event, index, config.fieldKey, config.flattenType)"
                                            class="w-100-pc-force" />
                                    </div>
                                </ng-container>
                            </td>
                        </ng-container>
                        <ng-template #showReadOnlyData>
                            <td>
                                <ng-container [ngSwitch]="config.fieldType">
                                    <span *ngSwitchCase="'COMBO'">{{ (data['flattenData'][config.flattenType][config.fieldKey] | technicalTranslate) || '-' }}</span>
                                    <span *ngSwitchCase="'DATE'">{{ (data['flattenData'][config.flattenType][config.fieldKey] | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR) || '-' }}</span>
                                    <span *ngSwitchDefault>{{ data['flattenData'][config.flattenType][config.fieldKey] || '-' }}</span>
                                </ng-container>
                            </td>
                        </ng-template>
                    </ng-container>

                </ng-container>
                <td>
                    <ng-container *ngIf="uiConfig['allowSearchAdd'] == 'ADD' || uiConfig['allowSearchAdd'] == 'BOTH'">
                        <a (click)="openCaptureClientModel(data)">
                            <i nz-icon nzType="edit" nzTheme="outline" class="m-r-5"></i>Edit
                        </a>
                        <nz-divider nzType="vertical"></nz-divider>
                    </ng-container>
                    <a nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="Remove" nzCancelText="Cancel"
                        (nzOnConfirm)="removeClientData(data, index)">
                        <i nz-icon nzType="delete" nzTheme="outline" class="m-r-5"></i>Delete
                    </a>
                </td>
            </tr>
        </tbody>
    </nz-table>
</div>

<nz-modal [(nzVisible)]="showCaptureClientModel" [nzTitle]="searchAddText +' '+ (_clientRole | technicalTranslate)"
    nzWidth="75%" [nzMaskClosable]="false" (nzOnCancel)="showCaptureClientModel = false;" [nzFooter]="null">
    <ng-container *nzModalContent>

        <app-register-client-details [uiConfig]="uiConfig" [clientDataObj]="currentClientDataObj"
            [captureRole]="_clientRole" (emitSelectedClientList)="emittedClientData($event)"></app-register-client-details>

    </ng-container>
</nz-modal>